import CheckCircle from '@/assets/CheckCircle'
import { motion } from 'framer-motion'
import PropTypes from "prop-types";
import { useTheme } from "@mui/material/styles";

const TonePill = (props) => {
  const theme = useTheme();
  const label = typeof props.label === 'string' ? props.label.trim() : props.label

  return (
    <motion.div
      layout
      initial={{ opacity: 0, scale: 0.8 }}
      animate={{ opacity: 1, scale: 1 }}
      exit={{ opacity: 0, scale: 0.8 }}
      transition={{ duration: 0.3, ease: "easeInOut" }}
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        background: props.active 
          ? "linear-gradient(0deg, #cff3fd, #cff3fd), #cff3fd"
          : label === 'Custom' ? '#F5F5F5' : '#FFFFFF',
        outline: props.active 
          ? `2px solid ${theme.palette.secondary.main}`
          : label === 'Custom' ? '1px dashed #C0C4CF' : '1px solid #C0C4CF',
        borderRadius: "90px",
        padding: "5px 12px",
        height: "40px",
        cursor: "pointer",
        position: "relative",
        width: "max-content"
      }}
    >
      <motion.div
        initial={{ opacity: 0, scale: 0.8, width: 0 }}
        animate={{ 
          opacity: props.active ? 1 : 0, 
          scale: props.active ? 1 : 0.8,
          width: props.active ? "auto" : 0
        }}
        transition={{ duration: 0.3, ease: "easeInOut" }}
        style={{
          display: "flex",
          alignItems: "center",
          overflow: "hidden",
          minWidth: 0,
        }}
      >
        <CheckCircle
          style={{
            marginRight: 7,
            display: 'block',
            flexShrink: 0,
          }}
        />
      </motion.div>
      
      <motion.span
        layout
        transition={{ duration: 0.3, ease: "easeInOut" }}
        style={{
          fontFamily: 'Inter',
          fontStyle: 'normal',
          fontWeight: 600,
          fontSize: '13px',
          lineHeight: '16px',
          color: '#1A1A1A',
          whiteSpace: 'nowrap'
        }}
      >
        {label}
      </motion.span>
    </motion.div>
  )
}

TonePill.propTypes = {
  active: PropTypes.bool,
  label: PropTypes.string
}

export default TonePill